var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.value)?_c('span',{staticClass:"text-success"},[_c('i',{staticClass:"far fa-check-circle"})]):_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"far fa-times-circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }